import { Route, Outlet } from "react-router-dom";
import { ProtectedRoute } from "../Router";
import lazyRoute from "@/router/lazy-route";

const AdminLayout = lazyRoute(() => import("@/layout/app/admin/AdminLayout"));
const CatalogLayout = lazyRoute(
  () => import("@/layout/app/admin/CatalogLayout")
);
const ProviderGroupLayout = lazyRoute(
  () => import("@/layout/app/admin/ProviderGroupLayout")
);
const ProviderGroupPatients = lazyRoute(
  () => import("@/pages/app/ProviderGroupPatients")
);
const AdminDashboard = lazyRoute(
  () => import("@/pages/app/admin/AdminDashboard")
);
const DataImport = lazyRoute(
  () => import("@/pages/app/admin/library/DataImport")
);
const CatalogCPTCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogCPTCodeCatalog")
);
const CatalogDiagnosisCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogDiagnosisCodeCatalog")
);
const CatalogDrugCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogDrugCatalog")
);
const CatalogHCPCSCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogHCPCSCodeCatalog")
);
const CatalogLOINCCodeCatalog = lazyRoute(
  () => import("@/pages/app/admin/library/catalog/CatalogLOINCCodeCatalog")
);
const FormBuilderHost = lazyRoute(
  () => import("@/pages/app/admin/library/form-builder/FormBuilderHost")
);
const FormBuilderTable = lazyRoute(
  () => import("@/pages/app/admin/library/form-builder/FormBuilderTable")
);
const NewTemplateTable = lazyRoute(
  () => import("@/pages/app/admin/library/templates/NewTemplateTable")
);
const TemplateNewForm = lazyRoute(
  () => import("@/pages/app/admin/library/templates/TemplateNewForm")
);
const ProviderGroupDepartments = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupDepartments")
);
const ProviderGroupLocations = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupLocations")
);
const ProviderGroupProfile = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupProfile")
);
const ProviderGroupProviders = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupProviders")
);
const ProviderGroupStaffUsers = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroupUsers")
);
const ProviderGroupsLayout = lazyRoute(
  () => import("@/pages/app/admin/provider-groups/ProviderGroups")
);
const AuditLog = lazyRoute(() => import("@/pages/app/admin/settings/AuditLog"));
const AdminProfile = lazyRoute(
  () => import("@/pages/app/admin/settings/Profile/AdminProfile")
);
const AdminUser = lazyRoute(
  () => import("@/pages/app/admin/tenant-settings/AdminUsers")
);
const RolesAndResponsibilities = lazyRoute(
  () => import("@/pages/app/admin/tenant-settings/RolesAndResponsibilities")
);
const TenantConfiguration = lazyRoute(
  () => import("@/pages/app/admin/tenant-settings/tenant-configuration")
);
const TenantProviders = lazyRoute(
  () => import("@/pages/app/admin/tenant-settings/tenant-providers")
);
const ProviderConfig = lazyRoute(
  () => import("@/pages/app/provider/settings/ProviderConfig")
);

export const AdminRoute = () => {
  return (
    <Route
      element={
        <ProtectedRoute accessingViewAs="admin">
          <AdminLayout />
        </ProtectedRoute>
      }
    >
      <Route index path="dashboard" element={<AdminDashboard />} />
      <Route path="provider-groups">
        <Route index element={<ProviderGroupsLayout />} />
        {/* future reference while you need page rather than modal */}
        {/* <Route path="location-id" element={<ProviderLocationIdLayout />}>
                <Route index element={<LocationDetails />} />
                <Route path="department" element={<LocationDepartment />} />
                <Route path="patient" element={<LocationPatient />} />
                <Route path="user" element={<LocationUser />} />
              </Route> */}
        {/* <Route path="users" element={<ProviderGroupUsersLayout />}>
                <Route path="staff/:staffId" element={<StaffUser />} />
                <Route path="provider/:providerId" element={<ProviderUser />} />
              </Route> */}
        <Route path=":providerGroupId/:uuid" element={<ProviderGroupLayout />}>
          <Route index element={<ProviderGroupProfile />} />
          <Route path="locations" element={<ProviderGroupLocations />} />
          <Route path="departments" element={<ProviderGroupDepartments />} />
          <Route path="patients" element={<ProviderGroupPatients />} />
          <Route path="users" element={<ProviderGroupStaffUsers />} />
          <Route path="providers" element={<ProviderGroupProviders />} />
          <Route path="configuration" element={<ProviderConfig />} />
        </Route>
      </Route>
      <Route path="library">
        <Route index element={<DataImport />} />
        <Route path="catalog" element={<CatalogLayout />}>
          <Route index element={<CatalogLOINCCodeCatalog />} />
          <Route path="drug-catalog" element={<CatalogDrugCatalog />} />
          <Route
            path="diagnosis-catalog"
            element={<CatalogDiagnosisCodeCatalog />}
          />
          <Route path="cpt-code-catalog" element={<CatalogCPTCodeCatalog />} />
          <Route
            path="hcpcs-code-catalog"
            element={<CatalogHCPCSCodeCatalog />}
          />
        </Route>
        <Route path="form-builder-list" element={<FormBuilderTable />} />
        <Route path="form-builder-host" element={<FormBuilderHost />} />
        <Route path="templates-list" element={<NewTemplateTable />} />
        <Route path="templates-host" element={<TemplateNewForm />} />
      </Route>

      <Route path="settings">
        <Route index element={<AdminProfile />} />
        <Route path="audit-log" element={<AuditLog />} />

        <Route
          path="roles-responsibility"
          element={<RolesAndResponsibilities />}
        />
      </Route>

      <Route path="tenant-settings">
        <Route index element={<TenantProviders />} />
        <Route path="admin-users" element={<Outlet />}>
          <Route index element={<AdminUser />} />
        </Route>
        <Route path="tenant-configuration" element={<TenantConfiguration />} />
      </Route>
    </Route>
  );
};
